<div *ngIf="isDNAEnabled" class="dna-container">

  <div class="dna-date" *ngIf="data.timestamp">{{data.timestamp | date:"dd-MM-YYYY"}}</div>

  <div class="dna-visual">

    <!-- dna helix canvas -->
    <div #dnaCanvasWrapper class="dna-canvas-wrapper">

      <div class="dna-canvas-animation">
        <canvas #dnacanvas id="dnacanvas"></canvas>
      </div>

    </div>

    <!-- dna data -->
    <div #dnaDataWrapper class="dna-data-wrapper" *ngIf="data.dnaData">

      <div class="dna-items">

        <div class="dna-item" *ngFor="let item of dnaDataEntries; trackBy: trackByKey">

          <div class="dna-content">

            <div class="dna-header">
              <h3 class="dna-title">{{item.key | translate}}</h3>
            </div>
            <!-- View mode -->
            <div class="dna-description" *ngIf="!editMode">
              {{item.value | join: ", "}}
            </div>
            <!-- Edit mode -->
            <div class="dna-description" *ngIf="editMode">
              <textarea class="form-control dna-edit-textarea"
                        rows="3"
                        [value]="editableData[item.key] || (item.value | join: ', ')"
                        (input)="onTextChange(item.key, $event)"
                        placeholder="{{'Enter values separated by commas...' | translate}}"></textarea>
              <small class="text-muted">{{'Separate items with commas' | translate}}</small>
            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>
